<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content>
  @for (message of messages; track message) {
    <p>{{message}}</p>
  }
</div>
<div mat-dialog-actions class="actions">
  <button mat-button mat-raised-button color="primary"  (click)="onButtonClicked()">{{buttonText}}</button>
</div>
